module.exports = __webpack_public_path__ + "img/ic_nav_next.5f24cd98.svg";